export const MENSAJE_AVISO_PASADO =
  "La fecha y hora del aviso no puede ser anterior a la actual";

export const MENSAJE_AVISO_POSTERIOR =
  "La fecha y hora del aviso no puede ser posterior a la fecha y hora de la tarea";

export function validarFechaAvisoPersonalizado(
  fechaAviso: string | null,
  fechaAvisoOriginal: string | null,
  fechaTarea: string,
  horaTarea: string,
  ahora = new Date(),
): string | null {
  if (!fechaAviso) {
    return null;
  }

  const avisoModificado = fechaAviso !== fechaAvisoOriginal;
  const fechaAvisoDate = new Date(fechaAviso);
  const ahoraHastaElMinuto = new Date(ahora);
  ahoraHastaElMinuto.setSeconds(0, 0);

  if (avisoModificado && fechaAvisoDate < ahoraHastaElMinuto) {
    return MENSAJE_AVISO_PASADO;
  }

  const fechaHoraTarea = new Date(`${fechaTarea}T${horaTarea}`);

  if (fechaAvisoDate > fechaHoraTarea) {
    return MENSAJE_AVISO_POSTERIOR;
  }

  return null;
}
